module.exports = __webpack_public_path__ + "img/share-vehicle.fff69304.svg";